import {DayFilter} from "./dayFilter"

export const DAYFILTERKEYS: any[] = [
    { Key: DayFilter.AllDays, Display: 'i18n:VIEW_STATIC_LIST.DAYFILTER.ALLDAYS' },
    { Key: DayFilter.WeekDays, Display: 'i18n:VIEW_STATIC_LIST.DAYFILTER.WEEKDAYS' },
    { Key: DayFilter.WeekendDays, Display: 'i18n:VIEW_STATIC_LIST.DAYFILTER.WEEKENDDAYS' }
];